import {ReplaySubject} from "rxjs/ReplaySubject";
import {Observable} from "rxjs/Observable";
import {Optional} from "../../../../js/util/Optional";
import {LocalStorageService} from "../../../../types/NgStorage";

export class IvSidebarService {

    public static id = "ivSidebarService";

    private sidebarStorageKey = "ivSidebarState";

    private stateChanges$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $localStorage: LocalStorageService) {
        this.init();
    }

    private init() {
        const state = Optional.of(this.$localStorage[this.sidebarStorageKey])
                              .orElse(true);
        this.stateChanges$.next(state);
    }

    public onStateChange(): Observable<boolean> {
        return this.stateChanges$.asObservable();
    }

    public stateChanged(state: boolean) {
        this.stateChanges$.next(state);
        this.$localStorage[this.sidebarStorageKey] = state;
    }

}
